import { GameCard } from '@optools/components/game-card';
import { Button } from '@optools/components/ui/button';
import { MilestoneScheduleGame } from '@optools/services/operator-gateway/milestones/types';
import { MediaState } from '@optools/services/operator-gateway/types/generated/graphql';
import { Link } from '@tanstack/react-router';

export interface MilestonesGamesProps {
  date: string;
  game: MilestoneScheduleGame;
}

export function MilestonesGameCard({ date, game }: MilestonesGamesProps) {
  const disabled = !game.content.some(({ mediaState }) => mediaState.state !== MediaState.OFF);

  return (
    <GameCard
      key={game.gamePk}
      actionButton={
        <Button asChild={!disabled} disabled={disabled} size="sm" variant="outline">
          <Link
            from="/"
            params={{ gamePk: game.gamePk }}
            search={{ date }}
            to="/milestones/$gamePk">
            Edit Milestones
          </Link>
        </Button>
      }
      game={game}
    />
  );
}
